<template>
  <div class="content_div">
    <el-card>
      <div slot="header" class="clearfix">
        <span>店铺信息维护</span>
      </div>

      <el-form ref="form" :model="data" :rules="rules" label-width="120px" v-loading="loading">
        <el-form-item label="店铺名称" prop="shopName">
          <el-input v-model="data.shopName" placeholder="请输入店铺名称" maxlength="100" show-word-limit></el-input>
        </el-form-item>
        
        <el-form-item label="营业执照">
          <square-crop-upload
            v-model="data.businessLicense"
            :max-size="2048*5"
            :auto-upload="true"
          />
          <div class="upload-tip">建议尺寸：800x600像素，支持jpg、png格式，大小不超过5MB</div>
        </el-form-item>

        <el-form-item label="门店照片">
          <square-crop-upload
            v-model="data.storePhoto"
            :max-size="2048*5"
            :auto-upload="true"
          />
          <div class="upload-tip">建议尺寸：800x600像素，支持jpg、png格式，大小不超过5MB</div>
        </el-form-item>

        <el-form-item label="店铺地址" prop="address">
          <el-input v-model="data.address" placeholder="请输入店铺地址" maxlength="255" show-word-limit></el-input>
        </el-form-item>

        <el-form-item label="店铺介绍">
          <el-input 
            v-model="data.introduction" 
            type="textarea" 
            :rows="6"
            placeholder="请输入店铺介绍，让客户更好地了解您的店铺" 
            maxlength="2000" 
            show-word-limit>
          </el-input>
        </el-form-item>

        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="data.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="备注">
          <el-input 
            v-model="data.remark" 
            type="textarea" 
            :rows="3"
            placeholder="请输入备注信息" 
            maxlength="500" 
            show-word-limit>
          </el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitForm" :loading="submitLoading">保存</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { getShopPage, insertShop, updateShop } from '@/api/ordering/shop'
import SquareCropUpload from '@/components/core/images/SquareCropUpload'

export default {
  name: 'ShopInfo',
  components: {
    SquareCropUpload
  },
  async created() {
    await this.loadShopInfo()
  },
  data() {
    return {
      loading: false,
      submitLoading: false,
      shopId: null,
      data: {
        shopName: null,
        businessLicense: null,
        storePhoto: null,
        address: null,
        introduction: null,
        status: 1,
        remark: null
      },
      rules: {
        shopName: [
          { required: true, message: '请输入店铺名称', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请输入店铺地址', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    // 加载店铺信息（一个租户只有一个店铺）
    async loadShopInfo() {
      this.loading = true
      try {
        const res = await getShopPage({ currentPage: 1, pageSize: 1 })
        if (res.code === 200 && res.data.records && res.data.records.length > 0) {
          const shop = res.data.records[0]
          this.shopId = shop.id
          this.data = {
            shopName: shop.shopName,
            businessLicense: shop.businessLicense,
            storePhoto: shop.storePhoto,
            address: shop.address,
            introduction: shop.introduction,
            status: shop.status,
            remark: shop.remark
          }
        }
      } catch (error) {
        console.error('加载店铺信息失败:', error)
        this.$message.error('加载店铺信息失败')
      } finally {
        this.loading = false
      }
    },

    // 图片上传由SquareCropUpload组件自动处理，不需要手动处理方法
    // handleBusinessLicenseSuccess 和 handleStorePhotoSuccess 方法已移除
    // beforeAvatarUpload 方法已移除，由组件内部处理

    // 提交表单
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.submitLoading = true
          try {
            let res
            if (this.shopId) {
              // 更新
              this.data.id = this.shopId
              res = await updateShop(this.data)
            } else {
              // 新增
              res = await insertShop(this.data)
            }
            
            if (res.code === 200) {
              this.$message.success(this.shopId ? '修改成功' : '新增成功')
              if (!this.shopId && res.data) {
                // 如果是新增，获取新创建的店铺ID
                await this.loadShopInfo()
              }
            } else {
              this.$message.error(res.message || '操作失败')
            }
          } catch (error) {
            console.error('保存失败:', error)
            this.$message.error('保存失败')
          } finally {
            this.submitLoading = false
          }
        }
      })
    },

    // 重置表单
    resetForm() {
      this.$refs.form.resetFields()
    }
  }
}
</script>

<style scoped>
.upload-tip {
  color: #999;
  font-size: 12px;
  margin-top: 5px;
}
</style>
